<template lang="pug">
VTimeline(density="compact")
  VTimelineItem(
    size="x-small"
    dot-color="primary"
  )
    strong {{ changedStr }}
    br
    small {{ i18n.t("TheComment.LastChanged") }}
</template>

<script setup lang="ts">
import { formatYMD } from "~/units/datetime";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  changed?: Date;
}>();

const i18n = useI18n();

const changedStr = computed<string>(() => {
  if (!props.changed) return "?";
  // Do not use any locale-sensitive methods like `Date.toLocaleDateString` here, because they cause hydration errors
  // on browsers that do not have the same locale settings as the server.
  return formatYMD(props.changed);
});
</script>
